const invoiceApprovalReasonModalTypes = {
    OVERPAYMENT: 'OVERPAYMENT',
    PARTIAL_PAYMENT: 'PARTIAL_PAYMENT',
};

export default invoiceApprovalReasonModalTypes;
